import React, { Fragment, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

const Manager = props => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button size="small" onClick={handleClickOpen}>Etiquetas</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="tag-manager-title"
        aria-describedby="tag-manager-description"
        fullWidth={true}
        maxWidth="lg"
      >
        <DialogTitle id="tag-manager-title">Administrar Etiquetas</DialogTitle>
        <DialogContent>
          <DialogContentText id="tag-manager-description">Etiquetas aplicadas al (los) recurso(s).</DialogContentText>
          {props.children}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default Manager;



// WEBPACK FOOTER //
// ./src/components/tags-manager/manager.js